import React from "react";
import * as Icons from "lucide-react";
import { expertise } from "../data/mock";

const Expertise = () => {
  return (
    <section id="expertise" className="section bg-[#0B1E3F] text-[#F8F5EE] relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-100" />
      <div className="max-w-7xl mx-auto container-px relative">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div className="reveal">
            <span className="eyebrow text-[#C9A961]" style={{ opacity: 1 }}>
              <span className="text-[#F8F5EE]/80">Areas of Expertise</span>
            </span>
            <h2 className="h-section text-3xl lg:text-5xl mt-6 text-[#F8F5EE]">
              Eight disciplines.
              <br />
              <span className="italic text-[#C9A961]">One trusted advisor.</span>
            </h2>
          </div>
          <p className="max-w-md text-[15px] text-[#F8F5EE]/70 leading-relaxed reveal">
            From accreditation rigour to architectural planning and medico-legal advisory — each engagement is designed for measurable, audit-ready outcomes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#F8F5EE]/10 border border-[#F8F5EE]/10">
          {expertise.map((e, i) => {
            const Ico = Icons[e.icon] || Icons.Sparkles;
            return (
              <div
                key={i}
                className="group bg-[#0B1E3F] p-7 lg:p-8 reveal hover:bg-[#0B1E3F]/70 transition-colors duration-500 cursor-default"
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="w-11 h-11 border border-[#C9A961]/40 text-[#C9A961] flex items-center justify-center group-hover:bg-[#C9A961] group-hover:text-[#0B1E3F] transition-colors duration-500">
                    <Ico size={20} />
                  </span>
                  <span className="text-[11px] tracking-[0.25em] text-[#F8F5EE]/40">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-serif text-xl text-[#F8F5EE] leading-tight">
                  {e.title}
                </h3>
                <p className="mt-3 text-[13.5px] leading-relaxed text-[#F8F5EE]/65">
                  {e.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Expertise;
